export default "__VITE_ASSET__1642aa27__"